import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VCard, _vm._g(_vm._b({
    style: _vm.styles
  }, 'v-card', _vm.$attrs, false), _vm.$listeners), [_vm.hasOffset ? _c('helper-offset', {
    attrs: {
      "inline": _vm.inline,
      "full-width": _vm.fullWidth,
      "offset": _vm.offset
    }
  }, [_vm.title || _vm.icon ? _c('div', {
    class: `position ${_vm.hasButtons || _vm.$slots.buttons ? 'spec-width' : ''}`,
    style: _vm.cardStyles
  }, [_c('div', {
    class: `card-info-box-bg px-2 bg-info-card-${_vm.color}`,
    staticStyle: {
      "height": "60px"
    }
  }, [_c('div', {
    staticClass: "card-info-box-title"
  }, [_vm.icon ? _c(VIcon, {
    staticStyle: {
      "color": "inherit",
      "min-width": "32px"
    },
    attrs: {
      "small": ""
    }
  }, [_vm._v("far " + _vm._s(_vm.icon))]) : _vm._e(), _vm.title && !_vm.icon ? [_vm._v(_vm._s(_vm.title))] : _vm._e()], 2)])]) : _vm._e(), _vm.hasButtons || _vm.$slots.buttons ? _c('div', {
    staticClass: "card-action-box"
  }, [_c('div', {
    staticClass: "card-action-box-bg px-2",
    style: `${_vm.borderStyle('border-top')}; height: 60px`
  }, [_vm._t("buttons", function () {
    return _vm._l(_vm.buttons, function (item, i) {
      return _c('span', {
        key: i
      }, [_vm._t("singleButton", function () {
        return [item.title && !_vm.isMobile ? _c('core-button', {
          attrs: {
            "data-cy": item.dataCy,
            "color": item.color || _vm.color,
            "title": item.tooltip,
            "disabled": item.type === 'submit' && !_vm.formValue || !_vm.validStates[i] || _vm.cloading || item.disabled,
            "type": item.type === 'submit' ? 'submit' : 'button',
            "tooltip": item.disabled ? '' : item.tooltip,
            "prepend-icon": item.icon,
            "href": item.href,
            "target": item.href && item.target
          },
          on: {
            "click": function ($event) {
              return _vm.exec(item.action);
            }
          }
        }, [_vm._v("\n                " + _vm._s(item.title) + "\n              ")]) : _c('core-button', {
          attrs: {
            "data-cy": item.dataCy,
            "color": item.color || _vm.color,
            "title": item.tooltip,
            "disabled": item.type === 'submit' && !_vm.formValue || !_vm.validStates[i] || _vm.cloading || item.disabled,
            "type": item.type === 'submit' ? 'submit' : 'button',
            "tooltip": item.disabled ? '' : item.tooltip,
            "prepend-icon": item.icon,
            "href": item.href,
            "target": item.href && item.target
          },
          on: {
            "click": function ($event) {
              return _vm.exec(item.action);
            }
          }
        })];
      }, {
        "button": item
      })], 2);
    });
  }, {
    "buttons": _vm.buttons
  })], 2)]) : _vm._e(), _vm.title && _vm.icon || _vm.note ? _c('div', {
    staticClass: "right-aligned-note"
  }, [_vm._v("\n      " + _vm._s(_vm.note || _vm.title) + "\n    ")]) : _vm._e()]) : _vm._e(), _c(VCardText, {
    style: `${_vm.borderStyle()}; border-radius: 4px;`
  }, [_vm._t("default")], 2), _vm.$slots.actions ? _c(VDivider, {
    staticClass: "mx-4"
  }) : _vm._e(), _vm.$slots.actions ? _c(VCardActions, [_vm._t("actions")], 2) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };